<template>
  <div class='home'>
    <div class='image-container' v-show='!isUserLogged'>
      <announcements></announcements>
      <img
        width='100%'
        height='auto'
        alt='Company Image'
        src='../assets/main-page-image.png'
      />
    </div>
    <div class='image-container' v-show='!isUserLogged'>
      <HelloWorld />
    </div>
    <div v-if='isUserLogged' >
      <div v-if='loadingData'>Loading Application Data...</div>
      <div v-else>
      <application-child-form
          :grid-title='inProgressAppGridTitle'
          :dataSource='inProgressRequests'
          :visibleColumns = 'inProgressAppVisibleColumns'
        />
        <application-child-form
          :grid-title='submittedAppGridTitle'
          :dataSource='submittedRequests'
          :visibleColumns = 'submittedAppVisibleColumns'
        />
        <application-child-form
          :grid-title='closedAppGridTitle'
          :dataSource='closedRequests'
          :visibleColumns = 'closedAppVisibleColumns'
        />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/hello-world.vue';
import { mapGetters } from 'vuex';
import ApplicationChildForm from '../modules/applications/components/application-child-form.vue';
import Announcements from '../modules/announcements/public/announcements.vue';
import {
  getInProgressApplications,
  getSubmittedApplications,
  getClosedApplications,
} from '../modules/applications/services/applications-api';

export default {
  name: 'Home',
  components: {
    HelloWorld,
    ApplicationChildForm,
    Announcements,
  },
  computed: {
    ...mapGetters({ isUserLogged: 'loggedUser', appHeader: 'appName' }),
  },
  data() {
    return {
      loadingData: true,
      inProgressAppGridTitle: 'In Progress Application',
      inProgressAppVisibleColumns: ['recNo', 'requestor', 'productName', 'requestDate', 'status', 'externalNotes', 'Commands'],
      closedAppGridTitle: 'Closed Application',
      closedAppVisibleColumns: ['recNo', 'requestor', 'productName', 'requestDate', 'invoiceNumber', 'status', 'externalNotes', 'Commands'],
      inProgressFilters: [
        'in progress',
        'invoiced',
        'pending payment',
        'pending credit allocation',
        'submitted - new application',
        'issued',
      ],
      submittedAppGridTitle: 'Submitted Application',
      inProgressRequests: null,
      submittedRequests: null,
      closedRequests: null,
      submittedAppVisibleColumns: ['recNo', 'requestor', 'productName', 'permitNo', 'requestDate', 'invoiceNumber', 'status', 'externalNotes', 'Commands'],
    };
  },
  created() {
    if (this.isUserLogged) this.fetchApplications();
  },
  watch: {
    isUserLogged(isUserLogged) {
      if (isUserLogged) this.fetchApplications();
    },
  },
  methods: {
    async fetchApplications() {
      const userId = this.isUserLogged.id;
      try {
        const inProgressTopTen = await getInProgressApplications(userId, 10);
        this.inProgressRequests = inProgressTopTen.data;
        const submittedTopTen = await getSubmittedApplications(userId, 10);
        this.submittedRequests = submittedTopTen.data;
        const closedTopTen = await getClosedApplications(userId, 10);
        this.closedRequests = closedTopTen.data;
        this.loadingData = false;

        const inProgress = await getInProgressApplications(userId);
        this.inProgressRequests = inProgress.data;
        const submitted = await getSubmittedApplications(userId);
        this.submittedRequests = submitted.data;
        const closed = await getClosedApplications(userId);
        this.closedRequests = closed.data;
      } catch (err) {
        // console.error(`getapplication_err:${err.Status}`);
      }
    },
  },
};

</script>

<style>
.image-container {
  padding: 0 16% 0 16%;
}
</style>
